import {
  getRelationshipSchemaItemType,
  isRelationshipEntityReference,
} from '@web-config-app/schema-utils';
import type { EntitySelectControlSchema } from '../../types/controls';
import { useEntityDetailsProps } from '../use-entity-details-props/use-entity-details-props';

export const useEntityReferenceSchemaType = ({
  schema,
}: {
  schema: EntitySelectControlSchema;
}) => {
  const entityReference = schema['x-entity-reference'];

  const { rootSchema } = useEntityDetailsProps();

  if (isRelationshipEntityReference(entityReference)) {
    const { type: entityType } = getRelationshipSchemaItemType(
      entityReference.relationship,
      rootSchema,
    );

    return entityType;
  }

  return entityReference.domainEntityType;
};
